import { FC, useEffect } from 'react'
import { RadioGroup } from '@headlessui/react'
import type { ERC20Names } from '@g4g/wallet-modal/types'
import useERC20Balance from '@g4g/wallet-modal/hooks/wallet/useERC20Balance'
import CheckoutPaymentTokenRadioOpt from './CheckoutPaymentTokenRadioOpt'
import { ShoppingCartTotal } from '../../../../shopping-cart/provider/types'
import { useCheckoutOpsDispatch } from '../../../CheckoutProvider'
import { useUpdateEffect } from 'react-use'
import { internalTokens } from '@g4g/wallet-modal/util/network'
import useInsufficientFundsTracker from '../../../hooks/useInsufficientFundsTracker'

const CheckoutPaymentTokenPicker: FC<{
  total: ShoppingCartTotal | undefined
  option: ERC20Names
}> = ({ total, option }) => {
  const dispatch = useCheckoutOpsDispatch()
  const { balances, loading, error } = useERC20Balance(internalTokens.map(({ name }) => name))
  const { insufficientToken } = useInsufficientFundsTracker(balances, total)

  useEffect(() => {
    dispatch({ type: 'update-insufficient-funds', ...insufficientToken })
  }, [insufficientToken, dispatch])

  useUpdateEffect(() => {
    if (error) {
      // Something went wrong when fetching balances
      dispatch({ type: 'set-error', errorMessage: error.detail.message })
    }
  }, [error])

  return (
    <RadioGroup
      className="flex justify-center space-x-4 sm:space-x-6"
      value={option}
      onChange={(option: ERC20Names) =>
        dispatch({ type: 'update-payment-option', paymentOption: option })
      }
    >
      {internalTokens.map(({ name, symbol }, i) => (
        <CheckoutPaymentTokenRadioOpt
          key={i}
          loading={loading}
          name={name}
          symbol={symbol}
          insufficientFunds={name === 'Purpose' ? insufficientToken.prps : insufficientToken.dubi}
          token={{
            totalBalance: { wei: balances?.total.wei[name], human: balances?.total.human[name] },
            locked:
              name === 'Purpose'
                ? { wei: balances?.locked?.wei[name], human: balances?.locked?.human[name] }
                : undefined,
            price: { wei: total?.price.crypto.wei[name], human: total?.price.crypto.human[name] },
          }}
        />
      ))}
    </RadioGroup>
  )
}

export default CheckoutPaymentTokenPicker
